// src/admin/pages/directory/DirectoryHome.jsx
import React from "react";
import { Navigate } from "react-router-dom";

export default function DirectoryHome() {
  return <Navigate to="/admin/directory/users" replace />;
}
